

export interface CoreSchoolSoftScheduleConfiguration {
    id: string
    webApp?: string
    eventFilters: string[]
    selectedEmail: SchoolSoftScheduleSelectedEmail
    eventNaming: SchoolSoftScheduleEventNaming
}

export enum SchoolSoftScheduleSelectedEmail {
    Undefined = 0,
    Email = 1,
    TeamsAccount = 2,
    ClassroomAccount = 3,
}

export enum SchoolSoftScheduleEventNaming {
    Undefined = 0,

    /// <summary>
    /// EventName = "Svenska"
    /// </summary>
    Subject = 1,

    /// <summary>
    /// EventName = "7A"
    /// </summary>
    Group = 2,

    /// <summary>
    /// EventName = "7A (Svenska)"
    /// </summary>
    GroupWithSubject = 3,

    /// <summary>
    /// EventName = "Svenska (7A)"
    /// </summary>
    SubjectWithGroup = 4,
}